module.exports = __webpack_public_path__ + "static/media/followedButton.ff0fbfd9.svg";